module.exports = __webpack_public_path__ + "img/news_01.0fe8e4b9.jpg";